import { render, staticRenderFns } from "./DetailPenerbitanKonfirmasi.vue?vue&type=template&id=26635214&"
import script from "./DetailPenerbitanKonfirmasi.vue?vue&type=script&lang=js&"
export * from "./DetailPenerbitanKonfirmasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports